import { useTheme } from "@mui/material/styles";
import logoWhite from "assets/images/logo.svg";

const Logo = () => {
  const theme = useTheme();
  return <img src={logoWhite} alt="eventpxl" width="120" />;
};

export default Logo;
